/* global Swiper */
// **********************************************************
// Hero slider
// **********************************************************

const heroSwiperElements = document.querySelectorAll('[data-slider="hero-image-slider"]');

Array.prototype.forEach.call(heroSwiperElements, (el) => {
  const heroSliderParent = el.closest('.sc-hero-image');
  const arrowRight = heroSliderParent.querySelectorAll('.swiper-button-next')[0];
  const arrowLeft = heroSliderParent.querySelectorAll('.swiper-button-prev')[0];
  const paginationElement = heroSliderParent.querySelectorAll('.swiper-pagination')[0];
  const heroSliderOptions = {
    threshold: 10,
    touchRatio: 0.33,
    watchOverflow: true,
    speed: 1000,
    preloadImages: false,
    autoHeight: false,
    lazy: {
      loadPrevNext: true,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: arrowRight,
      prevEl: arrowLeft,
    },
    pagination: {
      el: paginationElement,
      clickable: true,
    },
  };
  // eslint-disable-next-line no-unused-vars
  const heroSwiper = new Swiper(el, heroSliderOptions);
});
